import { FormProvider } from "react-hook-form";
import { PaywallCheckoutContextProvider } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { CheckoutErrorBoundary } from "./CheckoutErrorBoundary";
import { CheckoutPage } from "./CheckoutPage";
import { CheckoutWrapper } from "./CheckoutWrapper";
import { useCheckoutFormMethods } from "./hooks/useCheckoutFormMethods";
import { useCheckoutTitle } from "./hooks/useCheckoutTitle";
import type { CheckoutProps } from "./types/CheckoutProps";

export const Checkout = (props: CheckoutProps) => {
  const { shouldUseWrapper } = props;
  const formMethods = useCheckoutFormMethods(props);

  const title = useCheckoutTitle(props);

  const Wrapper =
    (shouldUseWrapper ?? true) ? CheckoutWrapper : CheckoutWrapper.Preview;

  return (
    <Wrapper title={title}>
      <CheckoutErrorBoundary checkoutProps={props}>
        <FormProvider {...formMethods}>
          <PaywallCheckoutContextProvider {...props}>
            <CheckoutPage />
          </PaywallCheckoutContextProvider>
        </FormProvider>
      </CheckoutErrorBoundary>
    </Wrapper>
  );
};
